import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { psyEvaluationsOptions, responseAnswersExtraColumns } from "./psyEvaluationsOptions";
import { psyEvaluationsTabs } from "./psyEvaluationsTabs";
import { PsyEvaluationHeader } from "./components/PsyEvaluationHeader";
import { PsyEvaluationScores } from "./components/PsyEvaluationScores";
import { PsyEvaluationScoresEdit } from "./components/PsyEvaluationScoresEdit";
import { InstrumentResponseCreateForm } from "./components/InstrumentResponseCreateForm";
import { psyEvaluationsActions } from "./psyEvaluationsActions";

export const psyEvaluationsFieldsQuery = [
	"*.*",
	"instrument_id.name",
	"instrument_id.scoring_notes",
	"treatment.client.*",
	"treatment.client.user_id.*",
	"treatment.client.clinic_id.name",
	"lead.*",
].join(",");

export const psyEvaluationsRoutes = [
	{
		path: "/instruments_responses",
		element: <Records entity="instruments_responses" fieldsQuery={psyEvaluationsFieldsQuery} options={psyEvaluationsOptions} />,
	},
	{
		path: "/instruments_responses/create",
		element: (
			<Record
				entity="instruments_responses"
				type="create"
				fieldsQuery={psyEvaluationsFieldsQuery}
				body={<InstrumentResponseCreateForm />}
			/>
		),
	},
	{
		path: "/instruments_responses/:id",
		element: (
			<Record
				entity="instruments_responses"
				type="detail"
				fieldsQuery={psyEvaluationsFieldsQuery}
				header={<PsyEvaluationHeader actions={psyEvaluationsActions} />}
				body={<DetailTabs tabs={psyEvaluationsTabs} />}
			/>
		),
		children: [
			{
				path: "/instruments_responses/:id/detail",
				element: <PsyEvaluationScores />,
			},
			{
				path: "/instruments_responses/:id/responses",
				element: (
					<RecordsRelated
						entity="response_answers"
						fieldsToQuery="*.*,instrument_item.text,instrument_item.metadata,instrument_item.number,instrument_item.instrument_dimensions.instrument_dimensions_id.id,instrument_item.instrument_dimensions.instrument_dimensions_id.name,answer_option.label,answer_option.score"
						fieldToFilter="instrument_response_id"
						recordsOptions={{
							relatedRecords: { hideCreationButton: true },
							extraOptions: { sort: "instrument_item.number" },
							dataGridOptions: {
								navigateToDetail: () => ".",
								extraColumns: responseAnswersExtraColumns,
							},
						}}
					/>
				),
			},
		],
	},
	{
		path: "/instruments_responses/:id/update",
		element: (
			<Record
				entity="instruments_responses"
				type="update"
				fieldsQuery={psyEvaluationsFieldsQuery}
				header={<PsyEvaluationHeader />}
				body={<PsyEvaluationScoresEdit />}
			/>
		),
	},
];
